// Barre d'ancrage sticky mobile pour Espace Pro Landing
// Apparaît au scroll quand le header disparaît

import React, { useState, useEffect } from 'react';

const SECTIONS = [
  { id: 'hero', label: 'Accueil' },
  { id: 'ecosysteme', label: 'Écosystème' },
  { id: 'boutique', label: 'Boutique' },
  { id: 'crm', label: 'CRM' },
  { id: 'assistant', label: 'Assistant' },
  { id: 'fondateur', label: 'Fondateur' },
];

const EspaceProMobileAnchors = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollingDown = currentScrollY > lastScrollY;
      
      // Afficher la barre après 250px de scroll vers le bas
      if (currentScrollY > 250 && scrollingDown) {
        setIsVisible(true);
      }
      // Cacher si on remonte en haut
      if (currentScrollY < 150) {
        setIsVisible(false);
      }
      
      setLastScrollY(currentScrollY);

      // Détecter la section active
      const scrollPos = currentScrollY + 150;
      for (let i = SECTIONS.length - 1; i >= 0; i--) {
        const section = document.getElementById(SECTIONS[i].id);
        if (section && section.offsetTop <= scrollPos) {
          setActiveSection(SECTIONS[i].id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 60;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  if (!isVisible) return null;

  return (
    <>
      <div className="espace-pro-mobile-anchors">
        <div className="anchors-scroll-container">
          {SECTIONS.map((section) => (
            <button
              key={section.id}
              onClick={() => scrollToSection(section.id)}
              className={`anchor-btn ${activeSection === section.id ? 'active' : ''}`}
            >
              {section.label}
            </button>
          ))}
        </div>
      </div>

      <style>{`
        .espace-pro-mobile-anchors {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1000;
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border-bottom: 1px solid rgba(0, 0, 0, 0.06);
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-100%);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 768px) {
          .espace-pro-mobile-anchors {
            display: block;
          }
        }

        .anchors-scroll-container {
          display: flex;
          gap: 6px;
          padding: 12px 16px;
          overflow-x: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;
          scroll-snap-type: x mandatory;
        }

        .anchors-scroll-container::-webkit-scrollbar {
          display: none;
        }

        .anchor-btn {
          flex-shrink: 0;
          padding: 8px 16px;
          font-size: 13px;
          font-weight: 500;
          color: #64748B;
          background: #f5f5f5;
          border: none;
          border-radius: 20px;
          cursor: pointer;
          transition: all 0.2s ease;
          scroll-snap-align: start;
          white-space: nowrap;
        }

        .anchor-btn:hover {
          color: #1E3A5F;
          background: #e8e8e8;
        }

        .anchor-btn.active {
          color: #fff;
          background: #1E3A5F;
          font-weight: 600;
        }
      `}</style>
    </>
  );
};

export default EspaceProMobileAnchors;
